$(function(){
  // Slick Carousel (testimonials)
  // --------------------------------------
  if($('.testimonials-carousel').length) {
    $('.testimonials-carousel').slick({
      autoplay: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      mobileFirst: true
    });
  }
  
  
  //  Tidio Chat move to up
  // --------------------------------------
  var footerHeight = $("#shopify-section-framework--footer").innerHeight();
  $(window).scroll(function(){
    var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop() + 280;
    if(footerHeight >= scrollBottom) {
      $("#tidio-chat #tidio-chat-iframe").css({"bottom" : "55px"});
    }
    else {
      $("#tidio-chat #tidio-chat-iframe").css({"bottom" : "35px"});
    }
  });
  
  
});





// Assign Header height after window load
// --------------------------------------

$(window).on('load', function() {
  // Sticky header
  var mainNav = $('.header--menu');
  var mobileNav = $('.header--mobile');
  var mainNavPos = mainNav.offset().top;

  $(window).scroll(function() {
    var mainHeader = $('#shopify-section-header');
    var scrollPos = $(this).scrollTop();
    if (scrollPos >= mainNavPos) {
      mainNav.addClass('header--menu--sticky');
    } else {
      mainNav.removeClass('header--menu--sticky');
    }

    if (scrollPos >= $('#shopify-section-announcement').innerHeight()) {
      mobileNav.addClass('header--menu--sticky');
    } else {
      mobileNav.removeClass('header--menu--sticky');
    }
  });

});